<template>
  <div ref="print_ref" style="display: block">
    <div style="width: 280px; height: 165px; border: 1px solid #333">
      <div style="display: flex; border-bottom: 1px solid #333">
        <img style="width: 50px; height: 20px" :src="logourl" alt="" />
        <div
          style="
            flex: 1;
            display: flex;
            align-items: center;
            line-break: anywhere;
            justify-content: center;
            padding: 6px 4px;
            font-size: 16px;
            font-weight: bold;
          "
        >
          {{ params.order }}
        </div>
      </div>
      <div style="display: flex">
        <div style="flex: 1; border-right: 1px solid #333">
          <div
            style="
              font-size: 40px;
              display: flex;
              align-items: center;
              justify-content: center;
              font-weight: bold;
              border-bottom: 1px solid #333;
              text-align: center;
            "
          >
            {{ params.order.slice(-4) }}
          </div>
          <div
            style="
              font-size: 28px;
              border-bottom: 1px solid #333;
              font-weight: bold;
              text-align: center;
              overflow: hidden;
              flex-wrap: wrap;
              display: flex;
              align-items: center;
              justify-content: center;
              height: 65px;
            "
          >
            {{ params.store }}
          </div>
          <div style="font-size: 12px; padding: 2px 0; margin-left: 4px">
            日期 :{{ params.date }}
          </div>
        </div>

        <div style="width: 90px; height: 100%; text-align: center">
          <div
            style="
              margin-bottom: 4px;
              font-size: 14px;
              overflow: hidden;
              font-weight: bold;
            "
          >
            <div style="overflow: hidden">{{ params.user_id }}</div>
            <div style="overflow: hidden">
              {{ hideUsername(params.user_name) }}
            </div>
            <div style="overflow: hidden">{{ params.phone }}</div>
          </div>
          <img
            id="qrcode"
            style="height: 80px; width: 80px"
            :src="params.qrCodeUrl"
            alt=""
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import QRCode from "qrcode";

export default {
  name: "PrintInCode",
  data() {
    return {
      print_ref: null,
      params: {
        store: "國際中心店",
        order: "test123456877861234",
        user_id: "53058",
        user_name: "敏杰",
        phone: "75057",
        qrcodeUrl: "",
        date: "2023年02月06日",
      },
      logourl: "",
    };
  },
  created() {},
  async mounted() {
    let _this = this;
    this.convertImgToBase64(
      "https://jyb-server.s3.ap-southeast-1.amazonaws.com/storage/logo/logo.png",
      function (base64Img) {
        _this.logourl = base64Img;
      }
    );
  },
  methods: {
    hideUsername(input) {
      // 处理输入类型：非数字和字符串返回###
      let str;
      if (typeof input === "number") {
        // 数字转为字符串
        str = input.toString();
      } else if (typeof input === "string") {
        // 字符串直接使用
        str = input;
      } else {
        // 其他类型返回###
        return "###";
      }

      const len = str.length;

      // 超过6位数：前面用#填充，保留最后四位
      if (len > 6) {
        const hashCount = len - 4;
        return "#".repeat(hashCount) + str.slice(-4);
      }
      // 长度为1时，全部显示
      else if (len === 1) {
        return str;
      }
      // 长度为2时：前面用#填充，保留最后1位
      else if (len === 2) {
        const hashCount = len - 1;
        return "#".repeat(hashCount) + str.slice(-1);
      }
      // 长度3-6时：前面用#填充，保留最后2位
      else {
        const hashCount = len - 2;
        return "#".repeat(hashCount) + str.slice(-2);
      }
    },
    async testPrint() {
      // test
      const qrCodeUrl = await this.generateQR("test00000001");
      this.params = {
        store: "海上居櫃會所",
        order: "test00000001",
        user_id: "50557",
        user_name: "敏杰",
        phone: "75057",
        qrCodeUrl,
        date: "2023年02月06日",
      };
      console.log(this.params);
      this.$nextTick(() => {
        try {
          let pp = this.$refs.print_ref.innerHTML;
          console.log(pp);
          LODOP.SET_PRINT_PAGESIZE(1, "80mm", "50mm");
          LODOP.ADD_PRINT_HTM("1%", "2%", "100%", "100%", pp);
          // LODOP.PREVIEW();
          // LODOP.PRINT_SETUP();
          LODOP.PRINT();
          cb("yes");
        } catch (e) {
          cb("error");
        }
      });
      // test
    },
    convertImgToBase64(url, callback, outputFormat) {
      let canvas = document.createElement("CANVAS"),
        ctx = canvas.getContext("2d"),
        img = new Image();
      img.crossOrigin = "Anonymous";
      img.onload = function () {
        canvas.height = img.height;
        canvas.width = img.width;
        ctx.drawImage(img, 0, 0);
        const dataURL = canvas.toDataURL(outputFormat || "image/png");
        callback.call(this, dataURL);
        canvas = null;
      };
      img.src = url;
    },
    async generateQR(text) {
      try {
        return await QRCode.toDataURL(text, {
          margin: 0,
          quality: 1,
        });
      } catch (err) {
        this.$Message.error("打印二维码生成失败，请重试");
        console.error(err);
      }
    },
    printCode(val, cb) {
      console.log(val);
      this.params = {
        store: "",
        order: "",
        user_id: "",
        user_name: "",
        phone: "",
        qrcodeUrl: "",
        date: "",
      };
      this.$Rq
        .requestAuth({
          url: this.$Api.deliverCode4,
          method: "get",
          data: {
            order: val.order,
            user_phone: val.user_phone,
            store_id: val.store_id,
          },
        })
        .then(async (res) => {
          if (res.code !== 0) {
            cb("error");
            return this.$Message.error(res.msg);
          }
          const resData = res.data || {};
          const qrCodeUrl = await this.generateQR(val.order);
          const phone = val.user_phone.substring(val.user_phone.length - 5);
          this.params = {
            store: resData.arrive_name,
            order: resData.order || val.order,
            user_id: resData.user_id,
            user_name: resData.user_name,
            phone,
            qrCodeUrl,
            date: resData.order_date,
          };
          console.log(this.params);
          this.$nextTick(() => {
            try {
              let pp = this.$refs.print_ref.innerHTML;
              console.log(pp);
              LODOP.SET_PRINT_PAGESIZE(1, "80mm", "50mm");
              LODOP.ADD_PRINT_HTM("1%", "2%", "100%", "100%", pp);
              // LODOP.PREVIEW();
              // LODOP.PRINT_SETUP();
              LODOP.PRINT();
              cb("yes");
            } catch (e) {
              cb("error");
            }
          });
        })
        .catch(() => {
          cb("error");
        });
    },
  },
};
</script>

<style scoped></style>
